import { ImageInternalInfo } from 'models';

export const getImageResolution = (internalImageInfo: DeepIMap<ImageInternalInfo>) => {
  const height = internalImageInfo && internalImageInfo.get('height');
  const width = internalImageInfo && internalImageInfo.get('width');

  return (width && height) ? `${width} x ${height}px` : 'N/A';
};
